import { keepPreviousData } from '@tanstack/react-query';
import useGetApi from 'src/api/useGetApi';
import { InboundEmailDTO } from 'src/types/application/InboundEmailDTO';

interface UseGetInboundEmailParams {
  inboundEmailId: string;
  enabled?: boolean;
  includeSplitDocuments?: boolean;
}

/**
 * Split-child documents (documents with a parentDocumentId) are excluded
 * from the email's attachments; pass includeSplitDocuments to also fetch
 * them in splitAttachments.
 */
const useGetInboundEmail = ({
  inboundEmailId,
  enabled = true,
  includeSplitDocuments = false,
}: UseGetInboundEmailParams) => {
  return useGetApi<InboundEmailDTO>({
    endpoint: `communications/inbound-emails/${inboundEmailId}`,
    queryParameters: includeSplitDocuments
      ? { includeSplitDocuments: true }
      : undefined,
    options: {
      enabled: enabled && !!inboundEmailId,
      // Keep showing the already-loaded email while the split-documents
      // refetch is in flight (the flag changes the query key).
      placeholderData: includeSplitDocuments ? keepPreviousData : undefined,
    },
  });
};

export default useGetInboundEmail;
